import { Message } from 'element-ui'
import eventbus from '@/util/eventBus.js'
const PollService = {
  instance: null,
  start({ requestFn, interval = 3000, successCondition }) {
    this.stop() // 确保单例运行

    const execute = () => {
      requestFn().then(res => {
        if (successCondition(res)) {
          Message.success('支付成功');
          eventbus.$emit('layoutGetDetail', '来自轮询的数据通知layout');
          eventbus.$emit('enterpriseGetDetail', '来自轮询的数据通知enterprise');
          this.stop()
        } else {
          this.instance = setTimeout(execute, interval)
        }
      }).catch(err => {
        console.error('轮询异常:', err)
        this.instance = setTimeout(execute, interval)
      })
    }

    execute()
  },
  stop() {
    if (this.instance) {
      clearTimeout(this.instance)
      this.instance = null
    }
  }
}

export default PollService
